import { rem, useResponsive } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Skeleton } from '@chakra-ui/react/skeleton';

type BuildListItemSkeletonProps = {
  canRunBuild: boolean;
  showAppInfo: boolean;
};
const BuildItemSkeleton = ({ canRunBuild, showAppInfo }: BuildListItemSkeletonProps) => {
  const { isMobile } = useResponsive();

  if (!isMobile) {
    return (
      <Box display="flex" borderRadius="8" overflow="hidden" marginTop="24">
        <Skeleton height="auto" flexShrink="0" width="8" backgroundColor="color/neutral/moderate" />
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            gap="12"
            borderBottom="1px solid"
            borderBottomColor="border/minimal"
          >
            <Box display="flex" padding="12" gap="12" alignItems="center" overflow="hidden">
              <Skeleton height="24" width="24" borderRadius="4" />
              {showAppInfo ? (
                <>
                  <Skeleton height="40" width="40" borderRadius="4" />
                  <Box display="flex" gap="4" flexDirection="column" flexGrow={1}>
                    <Skeleton height={rem(22)} width="128" />
                    <Skeleton height={rem(18)} width={rem(350)} />
                  </Box>
                </>
              ) : (
                <Skeleton height={rem(22)} width="128" />
              )}
            </Box>
            {canRunBuild ? (
              <Box display="flex" paddingRight="12" justifyContent="flex-end" flexGrow={1}>
                <Skeleton height="24" width={rem(70)} borderRadius="4" />
              </Box>
            ) : null}
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap="12">
            <Box display="flex" gap="12">
              <Skeleton height={rem(38)} width={rem(225)} />
              <Box display="flex" paddingLeft="12" paddingTop="8" paddingBottom="10px" paddingRight="12">
                <Skeleton height="20" width={rem(120)} />
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-end"
              paddingLeft="12"
              paddingTop="8"
              paddingBottom="10px"
              paddingRight="12"
              gap="12"
            >
              <Skeleton height="20" width={rem(72)} />
              <Skeleton height="20" width="64" />
              <Skeleton height="20" width="64" />
              <Skeleton height="20" width="64" />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box display="flex" borderRadius="8" overflow="hidden" marginTop="24">
      <Skeleton height="auto" flexShrink="0" width="8" backgroundColor="color/neutral/moderate" />
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" flexDirection="column" borderBottom="1px solid" borderBottomColor="border/minimal">
          <Box display="flex" alignItems="center" padding="12" gap="12">
            <Skeleton height="24" width="24" borderRadius="4" />
            {showAppInfo ? (
              <>
                <Skeleton height="40" width="40" borderRadius="4" />
                <Box display="flex" flexDirection="column" gap="2">
                  <Skeleton height={rem(22)} width={rem(94)} />
                  <Skeleton height={rem(18)} width="64" />
                </Box>
              </>
            ) : (
              <Skeleton height={rem(22)} width={rem(94)} />
            )}
          </Box>
          <Box display="flex" paddingX="12" paddingY="8" borderTop="1px solid" borderTopColor="border/minimal">
            <Skeleton height="16" width={rem(264)} />
          </Box>
        </Box>
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="column" width="100%">
            <Skeleton height={rem(38)} width="100%" />
            <Box display="flex" paddingX="12" paddingY="8">
              <Skeleton height="20" width={rem(120)} />
            </Box>
          </Box>
          <Box
            display="flex"
            borderTop="1px solid"
            borderTopColor="border/minimal"
            paddingLeft="12"
            paddingTop="8"
            paddingBottom="10px"
            paddingRight="12"
            gap="12"
            width="100%"
          >
            <Skeleton height="20" maxWidth={rem(72)} flexGrow={1} />
            <Skeleton height="20" maxWidth="64" flexGrow={1} />
            <Skeleton height="20" maxWidth="64" flexGrow={1} />
            <Skeleton height="20" maxWidth="64" flexGrow={1} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BuildItemSkeleton;
